export const adminScope = 'super_user';
